import styled from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';

const Header = styled.header`
  padding-inline: var(--spacing-8);
  position: sticky;
  top: var(--spacing-8);
  z-index: 10;

  @media ${mqLargeMin} {
    padding-inline-start: var(--spacing-16);
  }
`;

const SiteHeader = ({ children }: { children: React.ReactNode }) => {
  return <Header role='banner'>{children}</Header>;
};

export default SiteHeader;
